import { render, staticRenderFns } from "./real-name-buyer.vue?vue&type=template&id=187bea22&scoped=true&"
import script from "./real-name-buyer.vue?vue&type=script&lang=js&"
export * from "./real-name-buyer.vue?vue&type=script&lang=js&"
import style0 from "./real-name-buyer.vue?vue&type=style&index=0&id=187bea22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bea22",
  null
  
)

export default component.exports